import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CommonFunctions from "../Utils/CommonFunctions";

class Footer extends Component {
  constructor(props) {
    super(props);
    let urlParams = new URLSearchParams(window.location.search);
    let myParam = urlParams.get("mobile");
    this.state = {
      storyMapId: this.props.portalurl,
      scrolltop: false,
      images: [],
      activeIndex: 0,
      Footer: myParam == "yes" ? false : true,
      isAutoPlayActive: false,
      isFullScreen: false,
      view: null,
      language: CommonFunctions.getSelectedLanguage(), // get the selected language
    };
  }

  //goto scrolltop
  Scrolltopfun(e) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search);
    let myParam = urlParams.get("mobile");
    if (myParam == "yes") {
      this.setState({ Footer: false });
    }
    document.addEventListener("scroll", () => {
      const isTop = window.scrollY;
      if (isTop > 100) {
        this.setState({ scrolltop: true });
      } else {
        this.setState({ scrolltop: false });
      }
    });
  }

  render() {
    const { t } = this.props;
    var ThemesInfo = this.props.ThemesInfo;
    var ThemesItems = [];
    for (var i = 0; i < ThemesInfo.length; i++) {
      ThemesItems.push(
        <li>
          <Link to={ThemesInfo[i].href} onClick={this.Scrolltopfun.bind(this)}>
            {ThemesInfo[i].ThemeTitle}
          </Link>
        </li>
      );
    }
    return (
      <div>
        {this.state.Footer && (
          <footer className="text-lg-start">
            <div dir={t("direction")} className="container-fluid">
              <div className="row container m-auto p-0">
                <div
                  className="col-lg-9 col-md-9 col-sm-6 mb-1"
                  data-aos="fade-in"
                  data-aos-delay="0"
                >
                  <ul className="footer-list p-0">{ThemesItems}</ul>
                </div>
                <div
                  className="col-lg-3 col-md-3 col-sm-6 mb-1"
                  data-aos="fade-in"
                  data-aos-delay="0"
                >
                  <ul className="footer-social  p-0">
                    <li>
                      <a href="https://x.com/fgic_uae" target="_blank">
                        <i className="fab fa-my-x-twitter">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style={{ height: 14 }}
                          >
                            <path
                              fill={"white"}
                              d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                            />
                          </svg>
                        </i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/fgic_uae"
                        target="_blank"
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://wa.me/971547240288" target="_blank">
                        <i className="fab fa-whatsapp"></i>
                      </a>
                    </li>
                  </ul>
                  <ul className="footer-list2 p-0">
                    <li>
                      <Link to="/" onClick={this.Scrolltopfun.bind(this)}>
                        {t("HomePage")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/ContactUs">{t("ContactUs")}</Link>
                    </li>
                    <li>
                      <Link to="/PrivacyPolicy">{t("PrivacyPolicy")}</Link>
                    </li>
                    <li>
                      <Link to="/Disclaimer">{t("Disclaimer")}</Link>
                    </li>
                    <li>
                      <Link to="/TermsAndConditions">
                        {t("TermsConditions")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/StakeholderAck">
                        {t("StakeholderAcknowledgment")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/Sitemap">{t("Sitemap")}</Link>
                    </li>
                  </ul>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12 mb-1">
                  <p className="copyright-text">
                    <span
                      dangerouslySetInnerHTML={{ __html: t("CopyRight") }}
                    ></span>
                  </p>
                </div>
              </div>
              <a
                onClick={this.Scrolltopfun.bind(this)}
                className={this.state.scrolltop ? "show" : "hide"}
                id="top_button"
                title={t("backtop")}
              >
                <i className="fas fa-arrow-up"></i>
              </a>
            </div>
          </footer>
        )}
      </div>
    );
  }
}

export default withTranslation()(Footer);
